module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_25",
    attrs: {
      "id": "calibre_pb_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_26"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_26"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_18",
    attrs: {
      "id": "id_Toc100507709"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "block_26"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_27"
  }, [_vm._v("2014")]), _vm._v(" "), _c('p', {
    staticClass: "block_24"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_22"
  }, [_vm._v("The day that Mia Germaine ambled into my wreck of a life stretched into the most beautiful tragedy I would ever experience—if only it hadn’t required a blood sacrifice. The life of one I loved murdered at the hands of one I hated. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("It all started with death, and ended with death. My own sister, Alexis Worthington, was a too-young life snuffed out before her time. No prom dress shopping to max out Mom’s credit card. No getting wasted at her high school graduation party and regretting it. No “finding herself” at college. No husband to fight with. No kids to spoil. No regrets to enjoy and survive. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Alexis’s life boiled down to a meager turnout at a poor man’s funeral where even the post-ceremony snacks came out of a generic Ritz Crackers box. After twenty-two years being six feet under in the funeral home’s cheapest box, Alexis was a rag-shrouded pile of dust by now. Meanwhile, my own perpetual rot continued daily.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Worms of regret wriggled through my core. Parasites of depression bit at my flesh. I was always a moment away from becoming a soulless carcass—until Mia Germaine came along. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Nothing could quell the devastation that shattered me into pieces of a man I no longer recognized… except for love.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Me, Landon Worthington—a man who survived without love my entire childhood—would come to know love with such intimacy even Shakespeare couldn’t find words to describe it. I never understood it until Mia’s arrival on my doorstep. It was not a romantic infatuation with something shiny and pretty dangling in front of my face, lingering at my fingertips. Not a burning passion that sets sheets on fire. No, it was something so much deeper, much purer. A familiar embrace from someone whose heart you possess, and who possesses your own for eternity. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Few ever experience this kind of love. It takes more than a grand gesture to feel it. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("It takes something extraordinary. Something bigger than me, bigger than you, bigger than life. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("It’s salvation. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Mia "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("did")]), _vm._v(" save my life, after all. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("It was a shame she couldn’t save every part of me, the worst parts of me. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Some people leave footprints that wash away from the ebb and flow of life, while others cement them as a permanent reminder that they touched you in some meaningful way. Mia’s tracks, while heavy and burdened with her own suffering, welcomingly stomped all over me, leaving in their prints puddles of hope where before there was none.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("I had witnessed too much death, too much pain for one soul to bear, but Mia washed it all away with a question that spurred an investigation that would not only capture a "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("killer, but also free an innocent:   ")])]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("“Do you think he really did it?” ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("The query about my father’s conviction from two decades earlier challenged my own beliefs to the core. Was my father innocent of his crimes? ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("Until Mia came along, I never had the balls to find out. She gave me the heart I needed to press for answers.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("But this isn’t a love story. Not the conventional kind, anyway. This is a story of friendship. Only the beginning of one, for now. It’s a story of recovering from loss, finding yourself amid tragedy, and clinging to that lifesaver when it’s tossed to you in the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("I never gave up, even though I did eventually give in. Give in to what, you ask? Give in to the gift that Mia gave me. Together we would conquer our demons and rise from the wreckage of our mutual suffering. A father and son reconciled, and a victim’s eternal silence broken at last. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("I’ll warn you now that you aren’t going to get all the answers about my sister’s murder here. Not yet, at least. That’s a different tale, one that only Mia can tell. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("But you "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("will")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" get answers about how it all started, and how the bigger picture ends.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }, [_vm._v("While my brokenness started after Alexis’s murder in March of 1992, salvation was only twenty-two years behind it… ")]), _vm._v(" "), _c('p', {
    staticClass: "block_24"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_26"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c56064","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_008.vue
// module id = 81
// module chunks = 0